export default "__VITE_ASSET__Df3geA6p__"